// src/presentation/pages/ClinicalExamination/sections/LanguageSection.tsx
import React from "react";
import { CardTitle } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";
import { booleanRadioValue } from "../types";

interface LanguageSectionProps {
  difficultyFindingWords: boolean | null;
  difficultyUnderstandingSpeech: boolean | null;
  onDifficultyFindingWordsChange: (value: boolean) => void;
  onDifficultyUnderstandingSpeechChange: (value: boolean) => void;
}

export const LanguageSection: React.FC<LanguageSectionProps> = ({
  difficultyFindingWords,
  difficultyUnderstandingSpeech,
  onDifficultyFindingWordsChange,
  onDifficultyUnderstandingSpeechChange,
}) => {
  const { t } = useTranslation("patients");
  return (
    <div className=" border-gray-200">
      <div className="pb-3">
        <CardTitle className="text-base font-semibold text-gray-900">
          {t("clinicalSections.language.title")}
        </CardTitle>
      </div>
      <div className="space-y-6">
        {/* Difficulty Finding Words */}
        <div>
          <p className="text-sm text-gray-700 mb-3">
            {t("clinicalSections.language.findingWordsQuestion")}
          </p>
          <RadioGroup
            value={booleanRadioValue(difficultyFindingWords)}
            onValueChange={(val) =>
              onDifficultyFindingWordsChange(val === "true")
            }
            className="flex gap-6"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="true" id="words-yes" />
              <Label
                htmlFor="words-yes"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.yes")}
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="false" id="words-no" />
              <Label
                htmlFor="words-no"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.no")}
              </Label>
            </div>
          </RadioGroup>
        </div>

        {/* Difficulty Understanding Speech */}
        <div>
          <p className="text-sm text-gray-700 mb-3">
            {t("clinicalSections.language.understandingSpeechQuestion")}
          </p>
          <RadioGroup
            value={booleanRadioValue(difficultyUnderstandingSpeech)}
            onValueChange={(val) =>
              onDifficultyUnderstandingSpeechChange(val === "true")
            }
            className="flex gap-6"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="true" id="speech-yes" />
              <Label
                htmlFor="speech-yes"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.yes")}
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="false" id="speech-no" />
              <Label
                htmlFor="speech-no"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.no")}
              </Label>
            </div>
          </RadioGroup>
        </div>
      </div>
    </div>
  );
};
